import {Button} from "../../../../../components/button/Button";
import {CommonTranslationKey} from "../../CommonTranslationKey";
import {HierarchyTreeTranslationKey} from "../HierarchyTreeTranslationKey";
import {ICON_REGISTRY, IconName} from "./Icons";
import React, {useState} from "react";
import Dialog from "../../../../../components/dialogs/Dialog";
import DialogTitle from "../../../../../components/dialogs/DialogTitle";
import DialogContent from "../../../../../components/dialogs/DialogContent";
import {Box} from "@mui/material";
import DialogActions from "../../../../../components/dialogs/DialogActions";
import {CancelButton} from "../../../../../components/button/CancelButton";
import {createStyles, makeStyles} from "@mui/styles";
import {Theme} from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import theme from "../../../../../common/Theme";
import {_transl} from "../../../../../store/localization/TranslMessasge";

const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            dialogPaper: {
                maxHeight: "60vh",
                display: "flex",
                flexDirection: "column",
            },
            content: {
                flex: 1,
            },
            grid: {
                display: "grid",
                gridTemplateColumns: "repeat(10, 1fr)",
                gap: theme.spacing(1),
                height: "100%",
                overflowY: "auto",
            }
        })
);

type IconPickerDialogProps = {
    open: boolean;
    selected?: IconName;
    onClose: () => void;
    onConfirm: (icon: IconName) => void;
};

export function IconPickerDialog({open, selected, onClose, onConfirm}: IconPickerDialogProps) {
    const classes = useStyles();
    const [current, setCurrent] = useState<IconName | undefined>(selected);

    return (
            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{className: classes.dialogPaper}}>
                <DialogTitle id="icon-picker-dialog-title" onDialogClosed={onClose} title={_transl(HierarchyTreeTranslationKey.SELECT_ICON)}/>
                <DialogContent className={classes.content}>
                    <Box className={classes.grid}>
                        {Object.entries(ICON_REGISTRY).map(([name, Icon]) => (
                                <MuiButton
                                        key={name}
                                        onClick={() => setCurrent(name as IconName)}
                                        sx={{
                                            border: current === name ? "2px solid" : "1px solid transparent",
                                            borderColor: current === name ? theme.palette.primary.main : theme.palette.divider,
                                            borderRadius: 2,
                                        }}>
                                    <Icon fontSize="large"/>
                                </MuiButton>
                        ))}
                    </Box>
                </DialogContent>

                <DialogActions>
                    <CancelButton onClick={onClose}/>
                    <Button label={_transl(CommonTranslationKey.SELECT)}
                            color={"primary"}
                            variant={"contained"}
                            disabled={!current}
                            onClick={() => onConfirm(current!)}/>
                </DialogActions>
            </Dialog>
    );
}